<template>
  <div>
    <v-layout row wrap>
      <v-menu
        v-model="menuStart"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="inputDate"
            v-on="on"
            :label="labelName"
            :disabled="disabled"
            class="input-text-field"
            prepend-icon="event"
            hide-details
            readonly
          />
        </template>
        <v-date-picker
          v-model="inputDate"
          :allowed-dates="allowedDates"
          :day-format="formatDate"
          locale="ja"
        />
      </v-menu>
    </v-layout>
  </div>
</template>

<script>
import dayjs from 'dayjs'

const dateFormat = 'YYYY-MM-DD'

export default {
  name: 'AppDatePicker',
  props: {
    date: {
      type: String,
      default: null,
    },
    labelName: {
      type: String,
      default: null,
    },
    isStartDateLimit: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menuStart: false,
    }
  },
  computed: {
    inputDate: {
      get() {
        if (!this.date) return null
        return dayjs(this.date).format(dateFormat)
      },
      set(date) {
        this.menuStart = false
        this.$emit('inputDate', date)
      },
    },
  },
  methods: {
    formatDate(date) {
      return dayjs(date).format('D')
    },
    allowedDates(date) {
      if (this.isStartDateLimit) {
        return (
          (dayjs(date).isAfter(dayjs(), 'day') ||
            dayjs(date).isSame(dayjs(), 'day')) &&
          this.allowedDatesByPermitter(date)
        )
      } else {
        return true
      }
    },
  },
}
</script>

<style scoped>
.input-text-field {
  width: 120px;
}
</style>
